import { render, staticRenderFns } from "./Subscribers.vue?vue&type=template&id=56490bbd&scoped=true&"
import script from "./Subscribers.vue?vue&type=script&lang=js&"
export * from "./Subscribers.vue?vue&type=script&lang=js&"
import style0 from "./Subscribers.vue?vue&type=style&index=0&id=56490bbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56490bbd",
  null
  
)

export default component.exports